/* eslint-disable */


/**
 * Create styles for `<SettingsPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<SettingsPage />` styles
 */
const settingsPageStyles = ({ theme }) => ({
  root: {},
});

export default settingsPageStyles;
